/* Seal Subscriptions login: brand copy, icons, the art panel and a clear sent state.
   Loaded only on /a/subscriptions* from layout/theme.liquid. Seal owns the markup and
   tags every string with data-seal-t, so copy is swapped by key. Seal's own script loads
   late (three chained requests), so the form is shown straight away by the CSS and an
   early click is held here until Seal's click handler exists. Every write is done once
   and flagged, and the observer pauses while this file writes, so nothing can loop. */
(function(){
  'use strict';
  var COPY={
    customrportalloginform_title:'Manage your subscription',
    customrportalloginform_description:"Enter your email and we'll send a secure link. No password needed.",
    customrportalloginform_email_label:'Email address'
  };
  var BUTTON='Email me the link';
  var P={ envelope:'M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z', plane:'M227.32,28.68a16,16,0,0,0-15.66-4.08l-.15,0L19.57,82.84a16,16,0,0,0-2.49,29.8L102,154l41.3,84.87A15.86,15.86,0,0,0,157.74,248q.69,0,1.38-.06a15.88,15.88,0,0,0,14-11.51l58.2-191.94c0-.05,0-.1,0-.15A16,16,0,0,0,227.32,28.68ZM157.83,231.85l-.05.14,0-.07-40.06-82.3,48-48a8,8,0,0,0-11.31-11.31l-48,48L24.08,98.25l-.07,0,.14,0L216,40Z', lock:'M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z', clock:'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z', check:'M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z' };
  function svg(d){return '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="'+d+'"/></svg>'}

  // Seal loads a private jQuery (window.jQuery341) and binds its click handler on document
  function sealReady(){
    var $=window.jQuery341||window.jQuery; if(!$||!$._data)return false;
    var ev=$._data(document,'events'); return !!(ev&&ev.click&&ev.click.some(function(h){return h.selector&&h.selector.indexOf('send_customer_portal_login_link')>-1}));
  }

  function build(){
    var page=document.querySelector('#MainContent .seal-login-form'); if(!page)return;
    var host=page.querySelector('.seal-auto-min'), card=page.querySelector('.seal-container');
    if(!host||!card||host.classList.contains('hs-portal'))return;
    host.classList.add('hs-portal');

    var art=window.HS_SEAL_ART;
    if(art){
      var fig=document.createElement('figure'); fig.className='hs-portal-art';
      var img=new Image(); img.src=art; img.alt=''; img.decoding='async'; img.width=800; img.height=1000;
      fig.appendChild(img); host.insertBefore(fig,card);
    }

    // Seal's translator re-renders every [data-seal-t] from its own table once it loads,
    // so the copy goes into that table, then onto the page for the moments before Seal runs
    var BTN_HTML=svg(P.plane)+'<span>'+BUTTON+'</span>';
    var all={}; Object.keys(COPY).forEach(function(k){all[k]=COPY[k]}); all.customrportalloginform_button_action=BTN_HTML;
    var ss=window.sealsubscriptions;
    if(ss){
      [ss.translations].concat(ss.translationsGroupedByLanguage?Object.keys(ss.translationsGroupedByLanguage).map(function(l){return ss.translationsGroupedByLanguage[l]}):[]).forEach(function(t){
        if(t)Object.keys(all).forEach(function(k){t[k]=all[k]});
      });
    }
    Object.keys(all).forEach(function(key){
      var el=card.querySelector('[data-seal-t="'+key+'"]'); if(el)el.innerHTML=all[key];
    });

    var h2=card.querySelector('h2');
    if(h2){var eb=document.createElement('p'); eb.className='hs-eyebrow'; eb.textContent='Subscriptions'; card.insertBefore(eb,h2)}

    var fl=card.querySelector('.seal-floating-label'), inp=fl&&fl.querySelector('input.seal-input');
    if(inp){
      var w=document.createElement('div'); w.className='hs-field';
      inp.parentNode.insertBefore(w,inp); w.appendChild(inp);
      var ic=document.createElement('span'); ic.className='hs-field-icon'; ic.innerHTML=svg(P.envelope); w.appendChild(ic);
      inp.type='email'; inp.setAttribute('inputmode','email'); inp.setAttribute('autocomplete','email'); inp.setAttribute('autocapitalize','off'); inp.setAttribute('spellcheck','false');
      var lab=fl.querySelector('label'); if(lab&&!inp.id){inp.id='hs-portal-email'; lab.setAttribute('for',inp.id)}
    }

    var btn=card.querySelector('.seal-button');
    var msg=card.querySelector('[data-seal-customer-portal-success]');
    if(msg){msg.setAttribute('role','status'); msg.setAttribute('aria-live','polite')}

    // Sent panel: replaces the form once Seal confirms the request
    var sent=document.createElement('div'); sent.className='hs-sent'; sent.hidden=true; sent.setAttribute('tabindex','-1');
    sent.innerHTML='<span class="hs-sent-icon">'+svg(P.check)+'</span>'+
      '<h2 class="hs-sent-title">Check your inbox</h2>'+
      '<p class="hs-sent-body">If a subscription is linked to <strong class="hs-sent-email"></strong>, your secure link is on its way. It usually arrives within a minute.</p>'+
      '<p class="hs-sent-hint">Not there? Check spam or promotions, or try the email you used at checkout.</p>'+
      '<button type="button" class="hs-sent-back">Use a different email</button>';
    card.appendChild(sent);

    if(btn){
      var ul=document.createElement('ul'); ul.className='hs-reassure';
      ul.innerHTML='<li>'+svg(P.lock)+'<span>No password needed</span></li><li>'+svg(P.clock)+'<span>Link arrives within a minute</span></li>';
      btn.parentNode.insertBefore(ul,btn.nextSibling);
      btn.setAttribute('role','button'); btn.setAttribute('tabindex','0');

      // Seal's button is a div: give it the keyboard, and hold a click made before Seal has loaded
      var queued=false;
      btn.addEventListener('click',function(e){
        if(sealReady()||queued)return;
        e.stopImmediatePropagation(); queued=true; btn.classList.add('hs-sending');
        var tries=0, t=setInterval(function(){
          if(sealReady()){clearInterval(t); btn.classList.remove('hs-sending'); queued=false; (window.jQuery341||window.jQuery)(btn).trigger('click')}
          else if(++tries>100){clearInterval(t); btn.classList.remove('hs-sending'); queued=false; showError('This page is still loading. Please try again in a moment.')}
        },100);
      },true);
      btn.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();btn.click()}});
      // Seal listens for Enter on the input itself, so only step in before it has loaded
      if(inp)inp.addEventListener('keydown',function(e){if(e.key==='Enter'&&!sealReady()){e.preventDefault();btn.click()}});
    }

    function showError(text){
      if(!msg)return; pause(function(){msg.textContent=text; msg.classList.add('hs-is-error')});
    }

    var obs, paused=false;
    function pause(fn){paused=true; fn(); obs&&obs.takeRecords(); paused=false}

    function showSent(){
      if(!sent.hidden)return;
      pause(function(){
        sent.querySelector('.hs-sent-email').textContent=(inp&&inp.value.trim())||'your email';
        msg.textContent=''; msg.classList.remove('hs-is-error');
        card.classList.add('hs-is-sent'); sent.hidden=false;
      });
      sent.focus({preventScroll:true});
    }

    sent.querySelector('.hs-sent-back').addEventListener('click',function(){
      pause(function(){
        card.classList.remove('hs-is-sent'); sent.hidden=true;
        if(btn)btn.classList.remove('seal-portal-hide','seal-loading');
        if(inp){inp.value=''}
      });
      if(inp)inp.focus();
    });

    // Seal writes success, its empty-email check and its server error all into the same box
    function onSeal(){
      if(paused||!msg)return;
      var t=msg.textContent.trim();
      var done=btn&&btn.classList.contains('seal-portal-hide');
      if(done||/received your request/i.test(t)){showSent();return}
      var isError=!!t&&/valid email|went wrong/i.test(t);
      if(isError&&/went wrong/i.test(t)&&t.length<40){
        pause(function(){msg.textContent="We couldn't send the link just now. Please try again in a minute."});
      }
      pause(function(){msg.classList.toggle('hs-is-error',isError)});
    }

    if(msg&&btn){
      obs=new MutationObserver(onSeal);
      obs.observe(msg,{childList:true,characterData:true,subtree:true});
      obs.observe(btn,{attributes:true,attributeFilter:['class']});
    }
    if(inp)inp.addEventListener('input',function(){if(msg&&msg.classList.contains('hs-is-error'))pause(function(){msg.textContent='';msg.classList.remove('hs-is-error')})});

    host.classList.add('hs-ready');
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
})();
